import React, { useState } from "react";
import pl from "shared/messages/pl";
import { Dropdown, DropdownItemProps, Flex, Text } from "@fluentui/react-northstar";
import { CloseIcon } from "@fluentui/react-icons-northstar";

export interface MultipleChoiceFilterItem {
    value: any;
    valueAsString: string;
}

export interface MultipleChoiceFilterProps {
    label?: string;
    placeholder?: string;
    disabled?: boolean;
    availableChoices: MultipleChoiceFilterItem[];
    selectedChoices: MultipleChoiceFilterItem[];
    className?: string;
    notInverted?: boolean;
    onSelectionChanged: (selectedItems: any[]) => void;
    clearable?: boolean;
    isError?: boolean;
}

const MultipleChoiceFilter: React.FC<MultipleChoiceFilterProps> = (props) => {
    const [opened, setOpened] = useState<boolean>(false);
    const [searchQuery, setSearchQuery] = useState<string>("");

    const getItems = (): DropdownItemProps[] =>
        props.availableChoices.map((item) => ({
            header: item.valueAsString,
        }));

    const getSelectedItems = (): DropdownItemProps[] =>
        props.selectedChoices.map((item) => ({
            header: item.valueAsString,
            selected: props.selectedChoices.some((choice) => choice.valueAsString === item.valueAsString),
        }));

    const itemToValue = (item: DropdownItemProps) =>
        props.availableChoices.find((choice) => choice.valueAsString === item.header)?.value;

    const itemsToValues = (items: DropdownItemProps[] | undefined | null): any[] =>
        items ? items.map((item) => itemToValue(item)) : [];

    const renderDropdown = () => (
        <Dropdown
            search
            multiple
            clearable={props.clearable}
            open={opened}
            inverted={!props.notInverted}
            disabled={props.disabled}
            items={getItems()}
            value={getSelectedItems()}
            searchQuery={searchQuery}
            onSearchQueryChange={(_, data) => setSearchQuery(data.searchQuery!)}
            placeholder={props.placeholder}
            noResultsMessage={pl.taskBoardTopBar.filters.noSuggestionsFound}
            onFocus={() => setOpened(true)}
            onBlur={() => {
                setOpened(false);
                setSearchQuery("");
            }}
            onChange={(_, dropdown) => props.onSelectionChanged(itemsToValues(dropdown.value as DropdownItemProps[]))}
            className={props.className}
            clearIndicator={<CloseIcon style={{ color: "red" }} />}
            fluid
            error={props.isError}
        />
    );

    if (props.label) {
        return (
            <Flex column gap="gap.small">
                <Text>{props.label}</Text>
                {renderDropdown()}
            </Flex>
        );
    }

    return renderDropdown();
};

export default MultipleChoiceFilter;
